<template>
  <div>
    <b-row>
      <b-col sm="12">
        <div class="component-margin-half">
          <invoice-main-filter
            :freeWordFilter="freeWordFilter" :StatusFilter="StatusFilter" :fbanumberFilter="fbanumberFilter" :memberFilter="memberFilter"
            :recordCount="recordCount" :trackingNumberFilter="trackingNumberFilter"
            :filterStartDate="filterStartDate" :filterEndDate="filterEndDate" :searchCount="searchCount"
            :upsShippingQuantity="upsShippingQuantity" :upsShippingTotalWeight="upsShippingTotalWeight"
            @changeFreeWordFilter="($event) => freeWordFilter=$event"
            @changeMemberFilter="($event) => memberFilter=$event"
            @changeFbanumberFilter="($event) => fbanumberFilter=$event"
            @changeFilterStatus="($event) => statusFilter=$event"
            @changeTrackingNumberFilter="($event) => trackingNumberFilter=$event"
            @updateStartDate="($event) => filterStartDate=$event"
            @updateEndDate="($event) => filterEndDate=$event"
            @clickFilterSearchBtn="clickFilterSearchBtn()"
            @clickOutputLabel="clickOutputLabel()"
            @outputFile="getInvoiceMainCsv()"/>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table show-empty stacked="sm" bordered=true striped=true small=true hover=true
                :items="items" :fields="fields"
                :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="registeredDate" slot-scope="row"><label>{{formatDate(row.value)}}</label></template>
          <template slot="fbaNumber" slot-scope="row">
            <div><label>{{row.item['fbaNumber']}}</label></div>
            <div><label>({{row.item['trackingNumber']}})</label></div>
          </template>
          <template slot="shippingQuantity" slot-scope="row">
            <div><label>{{row.item['shippingQuantity']}}</label></div>
            <!-- <div><label>({{row.item['setItemQuantity']}})</label></div> -->
          </template>
          <template slot="totalPurchaseAmount" slot-scope="row">
            <label>{{formatPrice(row.value)}}</label>
            <label style="color: red" v-if="row.item['lithiumBatteryQuantity'] > 1">リチウム</label>
            <label style="color: blue" v-if="row.item['isRequireBattery']">乾電池</label>
          </template>
          <template slot="carrier" slot-scope="row">
            <label>{{shipmentTypeName(row.value)}}</label>
            <label v-if="row.value === '2' || row.value === '3' || row.value === '5'">【{{row.item['maxCategoryName']}} etc.】</label>
          </template>
          <template slot="statusMessage" slot-scope="row">
            <div v-for='(value, index) in row.item.statusMessage' :key='index'>
              {{ value }}
            </div>
          </template>
          <template slot="status" slot-scope="row">
            <label>{{dispInvoiceStatusTypeName(row.item)}}</label>
          </template>
          <template slot="shippingDate" slot-scope="row">
            <label>{{formatDate(row.value)}}</label>
            <b-button size="sm" class="component-margin-left-half" @click="updateBaseDataPre(row.item)" variant="warning">更</b-button>
          </template>
          <template slot="ugxNumber" slot-scope="row">
            <b-input size="sm" v-model="row.item['ugxNumber']" @change="changeUgxNumber(row.item)" :disabled="row.item['carrier'] === '2' || row.item['carrier'] === '3'" placeholder="" />
          </template>
          <template slot="comment" slot-scope="row">
            <b-textarea class="" v-model="row.item.comment"></b-textarea>
            <!-- <b-input size="sm" class="" v-model="row.item['comment']" placeholder="" /> -->
          </template>
          <template slot="update" slot-scope="row">
            <b-button size="sm" @click="updateInvoiceMainOther(row.item)" variant="danger">更新</b-button>
            <!-- <b-button v-else size="sm" @click="updateInvoiceMainOtherPre(row.item)" variant="danger">更新</b-button> -->
          </template>
          <template slot="invoiceCreate" slot-scope="row">
            <div v-if="row.item['isComplete']" >
              <b-button size="sm" @click="outputInvoiceData(row.item['invoiceUrl'])" variant="danger">出力</b-button>
              <label class="for-fbanumber" size="sm" @click="reCreateInvoice(row.item)">再作成</label>
            </div>
            <b-button v-else size="sm" @click="initCreateInvoice(row.item)" :disabled="row.item['isError'] == true" variant="danger">作成</b-button>
          </template>
          <template slot="dispDetail" slot-scope="row">
            <b-button size="sm" @click="dispDetailInfo(row.item)" variant="info">詳細</b-button>
            <label class="for-fbanumber" v-if="row.item['shippingLabelUrl'] != ''" size="sm" @click="outputLabel(row.item)">Label</label>
          </template>
          <template slot="doShipping" slot-scope="row">
            <b-button v-if="!row.item.isShippingStop" size="sm" @click="preCheckUpdateShippingStatus(row.item)" :disabled="row.item['isShipping'] || !row.item['isComplete']" variant="info">追跡</b-button>
            <b-button v-else size="sm" @click="preChangeStatusToShipped(row.item)" variant="info">発送</b-button>
          </template>
          <!-- <template slot="folderPath" slot-scope="row">
            <b-button size="sm" :href="getFolderURL(row.item)" variant="warning">フォルダ</b-button>
          </template> -->
        </b-table>
      </b-col>
    </b-row>
    <invoice-detail-modal ref="historyModal"/>
    <b-modal ref="updateBaseData" title="追跡番号＆発送日更新" @ok="updateBaseData">
      <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" label="追跡番号" label-for="trackingNumber">
        <b-form-input size="sm" id="trackingNumber" v-model="editItem.trackingNumber" type="text"/>
      </b-form-group>
      <b-form-group size="sm" horizontal label="発送日" label-class="text-sm-right" label-for="shippingDateModal">
        <date-picker id="shippingDateModal" class="table-linput zoom-back-3" :addclearbtn=false :dispMonth=false :notinitdate=true :value="editItem.shippingDate" @change="($event) => editItem.shippingDate = $event"/>
      </b-form-group>
    </b-modal>
    <b-modal ref="checkShipmentAmount" title="UGXの税関申告価格を入力してください" @ok="checkShipmentAmount">
      <b-form-group size="md" label-cols-sm="4" label-align-sm="right" label="送金金額" label-for="shipmentAmount">
        <b-form-input size="md" id="shipmentAmount" v-model="shipmentAmount" type="text"/>
      </b-form-group>
    </b-modal>
    <b-modal ref="preCheckUpdateShippingStatus" title="追跡番号を入力してください。" @ok="updateShippingStatus">
      <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" label="追跡番号" label-for="preCheckTrackingNumber">
        <b-form-input size="sm" id="preCheckTrackingNumber" v-model="preCheckTrackingNumber" type="text"/>
      </b-form-group>
    </b-modal>
    <b-modal ref="changeStatusToShipped" title="ステータス変更" @ok="changeStatusToShipped">
      <div class="text-center"><label>{{confirmMessageOkOnly}}</label></div>
    </b-modal>
    <b-modal ref="confirmMessage" ok-only hide-header>
      <div class="text-center"><label>{{confirmMessageOkOnly}}</label></div>
    </b-modal>
    <b-modal ref="checkPreInovoice" title="注意" @ok="createInvoice">
      <div class="text-center"><label>{{confirmMessageOkOnly}}</label></div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import MerchandiseManagementFilter from '@/components/management/MerchandiseManagementFilter';
import InvoiceMainFilter from '@/components/invoice/InvoiceMainFilter';
import ShipmentType from '@/types/ShipmentType';
import InvoiceStatusType from '@/types/InvoiceStatusType';
import InvoiceDetailModal from '@/components/invoice/InvoiceMainDetailModal';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      items: [],
      itemsForCSV: [],
      itemForUgxNumber: {},
      itemsForUpdateShippingStatus: [],
      preCheckTrackingNumber: '',
      editItem: {},
      freeWordFilter: '',
      fbanumberFilter: '',
      memberFilter: '',
      statusFilter: '0',
      // monthListFilter: '111111',
      trackingNumberFilter: '',
      filterStartDate: '',
      filterEndDate: '',
      upsShippingQuantity: 0,
      upsShippingTotalWeight: 0,
      shipmentAmount: '',
      fields: [
        { key: 'registeredDate',    label: '登録日', sortable: true, variant: 'base', class: 'table-lw7' },
        { key: 'memberId',     label: '会員番号', sortable: true, variant: 'base', class: 'table-lw6' },
        { key: 'memberName',     label: '氏名', sortable: true, variant: 'base', class: 'table-lw8' },
        { key: 'fbaNumber', label: 'FBA番号(追跡)', sortable: true, variant: 'base', class: 'table-lw9' },
        { key: 'shippingQuantity',    label: '商品数', sortable: false, variant: 'base', class: 'table-cw4' },
        { key: 'totalPurchaseAmount',    label: '購入金額', sortable: false, variant: 'base', class: 'table-rw5' },
        { key: 'carrier',     label: '発送業者', sortable: true, variant: 'base', class: 'table-lw7' },
        { key: 'shippingDate',       label: '発送日', sortable: true, variant: 'base', class: 'table-lw9' },
        { key: 'ugxNumber',     label: 'UGX番号',      sortable: true, variant: 'warning', class: 'table-lw9' },
        { key: 'comment',  label: 'コメント',   sortable: true, variant: 'warning', class: 'table-lw9'},
        { key: 'update',     label: '更新',      sortable: false, variant: 'warning', class: 'table-cw4' },
        { key: 'statusMessage', label: '取込結果', sortable: true, variant: 'success', class: 'table-rw9' },
        { key: 'status',  label: 'status',   sortable: true, variant: 'success', class: 'table-cw6' },
        { key: 'dispDetail',  label: '詳細',   sortable: true, variant: 'success', class: 'table-cw5' },
        { key: 'invoiceCreate',     label: '作成',      sortable: true, variant: 'success', class: 'table-cw5' },
        { key: 'doShipping',     label: '追跡',      sortable: true, variant: 'success', class: 'table-cw5' },
        { key: 'formCableQuantity',  label: 'Ca',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'formVideoQuantity',  label: 'Vi',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'formTscaQuantity',  label: 'Ts',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'formLaceyQuantity',  label: 'La',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'formWatchQuantity',  label: 'Wa',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'formTscaLaceyQuantity',  label: 'TL',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'formClockQuantity',  label: 'Cl',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'formRadecQuantity',  label: 'Ra',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'formDropQuantity',  label: 'Dr',   sortable: true, variant: 'base', class: 'table-cw3' },
        { key: 'lithiumBatteryQuantity',  label: 'リチ',   sortable: true, variant: 'base', class: 'table-cw4' },
      ],
      currentPage: 1,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      shipmentTypeName: ShipmentType.getValue,
      invoiceStatusTypeName: InvoiceStatusType.getStatusText,
      recordCount: 0,
      searchCount: 0,
      createFlg: 0,
      bkUgxNumber: '',
      confirmMessageOkOnly: ''
    };
  },
  created() {
    // フィルタの日付指定箇所に処理実行日を登録する。
    var dt = new Date();
    var y = dt.getFullYear();
    var m = ('00' + (dt.getMonth()+1)).slice(-2);
    var d = ('00' + dt.getDate()).slice(-2);
    this.filterStartDate = y + m + d;
    this.filterEndDate = y + m + d;

    api.getInvoiceMain(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, (data) => {
      this.items = data.invoiceMainList;
      this.recordCount = this.items.length;
      this.searchCount = data.searchCount;
      this.upsShippingQuantity = data.upsShippingQuantity;
      this.upsShippingTotalWeight = data.upsShippingTotalWeight;
      this.addCellVariant(this.items);
    });
  },
  computed: {
    // filteredItems() {
    //   let filteredItems = this.items.filter(item => {
    //     return (this.freeWordFilter === '' || (item.memberId !== null && item.memberId === this.freeWordFilter) ||
    //             (item.memberName !== null && item.memberName.toUpperCase().indexOf(this.freeWordFilter.toUpperCase()) !== -1) ||
    //             (item.trackingNumber !== null && item.trackingNumber.toUpperCase().indexOf(this.freeWordFilter.toUpperCase()) !== -1) ||
    //             (item.fbaNumber !== null && item.fbaNumber.toUpperCase().indexOf(this.freeWordFilter.toUpperCase()) !== -1));
    //   });
    //   this.recordCount = filteredItems.length;
    //   this.currentPage = 1;
    //   return filteredItems;
    // },
  },
  methods: {
    reCreateInvoice(item){
      this.createFlg = '1';
      this.editItem =  Object.assign({}, this.editItem , item);
      this.createInvoice();
    },
    initCreateInvoice(item){
      this.createFlg = '0';
      this.editItem =  Object.assign({}, this.editItem , item);
      if(item.lithiumBatteryQuantity >= 2){
        this.confirmMessageOkOnly = 'リチウム表示の必要な荷物です';
        this.$refs.checkPreInovoice.show();
      } else if(item.isRequireBattery){
        this.confirmMessageOkOnly = '乾電池表示の必要な荷物です';
        this.$refs.checkPreInovoice.show();
      } else{
        this.createInvoice();
      }
    },
    createInvoice() {
      api.createInvoiceMain(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, this.createFlg, this.editItem, (data) => {
        this.items = data.invoiceMainList;
        this.recordCount = this.items.length;
        this.searchCount = data.searchCount;
        this.upsShippingQuantity = data.upsShippingQuantity;
        this.upsShippingTotalWeight = data.upsShippingTotalWeight;
        this.addCellVariant(this.items);
        this.confirmMessageOkOnly = 'Invoice作成処理が完了しました。';
        this.$refs.confirmMessage.show();

        // Invoiceをダウンロードする
        if(data.invoiceUrl != null && data.invoiceUrl !== ''){
          this.outputInvoiceData(data.invoiceUrl);
        }
      });
    },
    outputInvoiceData(invoiceUrl){
        let anchor = document.createElement('a');
        anchor.href = invoiceUrl;
        anchor.target = '_blank';
        anchor.click();
    },
    preCheckUpdateShippingStatus(item){
      this.itemsForUpdateShippingStatus = item;
      this.$refs.preCheckUpdateShippingStatus.show();
    },
    preChangeStatusToShipped(item){
      this.itemsForUpdateShippingStatus = item;
      this.confirmMessageOkOnly = '強制でステータスを発送済みに更新します。';
      this.$refs.changeStatusToShipped.show();
    },
    changeStatusToShipped(){
      // 追跡番号チェックの結果が問題ない場合にメイン処理を実施
      api.changeStatusToShipped(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, this.itemsForUpdateShippingStatus, (data) => {
        this.items = data.invoiceMainList;
        this.recordCount = this.items.length;
        this.searchCount = data.searchCount;
        this.upsShippingQuantity = data.upsShippingQuantity;
        this.upsShippingTotalWeight = data.upsShippingTotalWeight;
        this.addCellVariant(this.items);
        // this.confirmMessageOkOnly = '発送済みに更新しました。';
        // this.$refs.confirmMessage.show();
      });
    },
    updateShippingStatus(){
      // 追跡番号チェックの結果が問題ない場合にメイン処理を実施
      if(this.itemsForUpdateShippingStatus.trackingNumber !== this.preCheckTrackingNumber){
        this.confirmMessageOkOnly = '入力した追跡番号が一致しません';
        this.$refs.confirmMessage.show();
        return;
      }
      api.updateShippingStatus(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, this.itemsForUpdateShippingStatus, (data) => {
        this.items = data.invoiceMainList;
        this.recordCount = this.items.length;
        this.searchCount = data.searchCount;
        this.upsShippingQuantity = data.upsShippingQuantity;
        this.upsShippingTotalWeight = data.upsShippingTotalWeight;
        this.addCellVariant(this.items);
        // this.confirmMessageOkOnly = '発送済みに更新しました。';
        // this.$refs.confirmMessage.show();
      });
    },
    // updateInvoiceMainOtherPre(item){
    //   this.editItem =  Object.assign({}, this.editItem , item);
    //   this.$refs.updateOther.show();
    // },
    // updateInvoiceMainOtherForPouup(){
    //   api.updateInvoiceMainOther(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.monthListFilter, this.editItem, (data) => {
    //     this.items = data.invoiceMainList;
    //     this.addCellVariant(this.items);
    //     this.confirmMessageOkOnly = '更新処理が完了しました。';
    //     this.$refs.confirmMessage.show();
    //   });
    // },
    updateInvoiceMainOther(item){
      api.updateInvoiceMainOther(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, item, (data) => {
        this.items = data.invoiceMainList;
        this.recordCount = this.items.length;
        this.searchCount = data.searchCount;
        this.upsShippingQuantity = data.upsShippingQuantity;
        this.upsShippingTotalWeight = data.upsShippingTotalWeight;
        this.addCellVariant(this.items);
        this.confirmMessageOkOnly = '更新処理が完了しました。';
        this.$refs.confirmMessage.show();
      });
    },
    updateBaseDataPre(item){
      this.editItem =  Object.assign({}, this.editItem , item);
      this.$refs.updateBaseData.show();
    },
    updateBaseData(){
      api.updateInvoiceMainBaseData(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, this.editItem, (data) => {
        this.items = data.invoiceMainList;
        this.recordCount = this.items.length;
        this.searchCount = data.searchCount;
        this.upsShippingQuantity = data.upsShippingQuantity;
        this.upsShippingTotalWeight = data.upsShippingTotalWeight;
        this.addCellVariant(this.items);
        this.confirmMessageOkOnly = '更新処理が完了しました。';
        this.$refs.confirmMessage.show();
      });
    },
    // changeMonthListFilter($event){
    //   this.registeredDateFilter = $event;
    // },
    changeUgxNumber(item){
      this.itemForUgxNumber = item;
      this.$refs.checkShipmentAmount.show();
    },
    checkShipmentAmount(){
      if(this.itemForUgxNumber['totalPurchaseAmount'] != this.shipmentAmount){
        this.itemForUgxNumber['ugxNumber'] = '';
        this.addCellVariant(this.items);
        this.confirmMessageOkOnly = '入力された税関申告価格と発送金額が一致しません。';
        this.$refs.confirmMessage.show();
      }
      this.shipmentAmount = '';
    },
    clickFilterSearchBtn(){
      api.getInvoiceMain(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, (data) => {
        this.items = data.invoiceMainList;
        this.recordCount = this.items.length;
        this.searchCount = data.searchCount;
        this.upsShippingQuantity = data.upsShippingQuantity;
        this.upsShippingTotalWeight = data.upsShippingTotalWeight;
        this.addCellVariant(this.items);
      });
    },
    outputLabel(item){
      let shipmentLabelUrl = item['shippingLabelUrl'];
      let anchor = document.createElement('a');
      anchor.href = shipmentLabelUrl;
      anchor.target = '_blank';
      anchor.click();
    },
    dispInvoiceStatusTypeName(item){
      if(item['isShipping']){
        return '発送済';
      } else if(item['isShippingStop']){
        return '発送保留';
      } else if(item['isComplete']){
        return '作成済';
      }
      return '未出力';
    },
    dispDetailInfo(item){
      // console.log(item);
      // console.log("fbaNumber:" + item.fbaNumber);
      // api.getInvoiceMainDetailInfo(item, (data) => {
      api.getInvoiceProductMasterByFbaNumber(item.fbaNumber, (data) => {
        // console.log(data.productMasterList);
        this.$refs.historyModal.showModal(data);
        // this.addCellVariant(this.items);
      });
    },
    getInvoiceMainCsv() {
      api.getInvoiceInfo(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, (data) => {
        // Invoiceをダウンロードする
        if(data.invoiceUrl != null && data.invoiceUrl !== ''){
          this.outputInvoiceData(data.invoiceUrl);
        }
      });
    },
    outputInvoiceData(invoiceUrl){
        let anchor = document.createElement('a');
        anchor.href = invoiceUrl;
        anchor.target = '_blank';
        anchor.click();
    },
    // outputCsv() {
    //   api.getInvoiceInfo(this.statusFilter, this.memberFilter, this.fbanumberFilter, this.trackingNumberFilter, this.filterStartDate, this.filterEndDate, (data) => {
    //     this.itemsForCSV = data.invoiceMainCSVInfoList;
    //     let header = '\ufeff' + '発送日,追跡番号,FBA番号,保険有無,まとめ送料,保険料,関税実費分,大型手数料,インボイス基本料,登録料,納品料,インボイス料,通関料,セット料,ラベル貼り料,インポータ料,料金合計,Filler1,合計価格,登録数,納品数,セット商品数,ラベル貼り数,フォーム作成数,その他,適応重量,実際重量合計,容積重量合計,Filler2,まとめ重量,箱①料金,箱①適応重量,箱①実際重量,箱①容積重量,箱①縦(cm）,箱①横(cm),箱①高さ(cm),Filler3,箱②料金,箱②適応重量,箱②実際重量,箱②容積重量,箱②縦(cm）,箱②横(cm),箱②高さ(cm),Filler4,箱③料金,箱③適応重量,箱③実際重量,箱③容積重量,箱③縦(cm）,箱③横(cm),箱③高さ(cm),Filler5,箱④料金,箱④適応重量,箱④実際重量,箱④容積重量,箱④縦(cm）,箱④横(cm),箱④高さ(cm),Filler6,箱⑤料金,箱⑤適応重量,箱⑤実際重量,箱⑤容積重量,箱⑤縦(cm）,箱⑤横(cm),箱⑤高さ(cm),会員番号,会員名,UGX\n';
    //     let ids = ['shippingDate','trackingNumber','fbaNumber','isInsurance','shippingCost','insuranceFee','customFee','largeItemFee','invoiceBaseFee','registeredFee','inboundFee','invoiceFee','clearanceFee','setItemFee','labelingFee','importerFee','totalFee','filler1','totalPurchaseAmount','registeredNumber','totalItemQuantity','setItemQuantity','labelingQuantity','formNumber','otherQuantity','weightTokusyu','totalWeight','totalVolumeWeight','filler2','matomeWeight','box1Price','lastWeight1','weight1','volumeWeight1','length1','width1','height1','filler3','box2Price','lastWeight2','weight2','volumeWeight2','length2','width2','height2','filler4','box3Price','lastWeight3','weight3','volumeWeight3','length3','width3','height3','filler5','box4Price','lastWeight4','weight4','volumeWeight4','length4','width4','height4','filler6','box5Price','lastWeight5','weight5','volumeWeight5','length5','width5','height5','memberId','memberName','ugxNumber'];
    //     this.outputFile(this.itemsForCSV, header, ids, 'Invoice_main_info.csv');
    //   });
    // },
    // outputFile(itemsForCSV, header, ids, fileName) {
    //   let csv = header;
    //   for (const item of itemsForCSV) {
    //     // if(!item['activeRecord']) {
    //     //   continue;
    //     // }
    //     csv = csv + '"';
    //     for (const id of ids) {
    //       if(item[id] == null){
    //         csv += '","';
    //       } else{
    //         csv += item[id] + '","';
    //       }
    //     }
    //     csv = csv.substring(0, csv.length - 2);
    //     csv += '\n';
    //   }
    //   const blob = new Blob([csv], { type: 'text/csv' });
    //   const link = document.createElement('a');
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = fileName;
    //   link.click();
    // },
    addCellVariant(items) {
      for (const v of items) {
        const errorCells = [];
        if (v['isError'] === true) {
          errorCells['statusMessage'] = 'danger';
        }
        if (v['isShippingStop']) {
          errorCells['registeredDate'] = 'danger';
          errorCells['memberId'] = 'danger';
          errorCells['memberName'] = 'danger';
          errorCells['fbaNumber'] = 'danger';
          errorCells['totalPurchaseAmount'] = 'danger';
          errorCells['shippingQuantity'] = 'danger';
          errorCells['carrier'] = 'danger';
          errorCells['shippingDate'] = 'danger';
          errorCells['ugxNumber'] = 'danger';
          errorCells['comment'] = 'danger';
          errorCells['update'] = 'danger';
          errorCells['statusMessage'] = 'danger';
          errorCells['status'] = 'danger';
          errorCells['dispDetail'] = 'danger';
          errorCells['invoiceCreate'] = 'danger';
          errorCells['doShipping'] = 'danger';
          errorCells['folderPath'] = 'danger';
          errorCells['formCableQuantity'] = 'danger';
          errorCells['formVideoQuantity'] = 'danger';
          errorCells['formTscaQuantity'] = 'danger';
          errorCells['formLaceyQuantity'] = 'danger';
          errorCells['formWatchQuantity'] = 'danger';
          errorCells['formTscaLaceyQuantity'] = 'danger';
          errorCells['formClockQuantity'] = 'danger';
          errorCells['formRadecQuantity'] = 'danger';
          errorCells['formDropQuantity'] = 'danger';
          errorCells['lithiumBatteryQuantity'] = 'danger';
        }
        if (v['isShipping']) {
          errorCells['registeredDate'] = 'primary';
          errorCells['memberId'] = 'primary';
          errorCells['memberName'] = 'primary';
          errorCells['fbaNumber'] = 'primary';
          errorCells['totalPurchaseAmount'] = 'primary';
          errorCells['shippingQuantity'] = 'primary';
          errorCells['carrier'] = 'primary';
          errorCells['shippingDate'] = 'primary';
          errorCells['ugxNumber'] = 'primary';
          errorCells['comment'] = 'primary';
          errorCells['update'] = 'primary';
          errorCells['statusMessage'] = 'primary';
          errorCells['status'] = 'primary';
          errorCells['dispDetail'] = 'primary';
          errorCells['invoiceCreate'] = 'primary';
          errorCells['doShipping'] = 'primary';
          errorCells['folderPath'] = 'primary';
          errorCells['formCableQuantity'] = 'primary';
          errorCells['formVideoQuantity'] = 'primary';
          errorCells['formTscaQuantity'] = 'primary';
          errorCells['formLaceyQuantity'] = 'primary';
          errorCells['formWatchQuantity'] = 'primary';
          errorCells['formTscaLaceyQuantity'] = 'primary';
          errorCells['formClockQuantity'] = 'primary';
          errorCells['formRadecQuantity'] = 'primary';
          errorCells['formDropQuantity'] = 'primary';
          errorCells['lithiumBatteryQuantity'] = 'primary';
        }
        v['_cellVariants'] = errorCells;
      }
    },
  },
};

Vue.component('merchandise-management-filter', MerchandiseManagementFilter);
// Vue.component('merchandise-management-summary', MerchandiseManagementSummary);
Vue.component('invoice-detail-modal', InvoiceDetailModal);
Vue.component('invoice-main-filter', InvoiceMainFilter);

</script>

<style>
.for-fbanumber{
  text-decoration: underline;
  cursor: pointer;
}
.component-margin-top-half {
  margin-top: .5rem;
}
.component-margin-half {
  margin-bottom: .5rem;
}
.component-margin {
  margin-bottom: 1rem;
}
.component-margin-left-half {
  margin-left: .5rem;
}
.text-window {
    padding: 1em;
    background-color: lightblue;
}
th.table-base {
  background-color: aliceblue!important;
}
th.table-ans {
  background-color: beige!important;
}
.image {
  align-content: center;
}
table > thead > tr > th {
  text-align: center!important;
}
th.table-base {
  background-color: aliceblue!important;
}
/* th.table-warning {
  background-color: gray;
} */
td.table-success{
  background-color: rgba(40,167,69,.25);
}
td.table-warning{
  background-color: #ffeeba59;
}
table label{
  margin-bottom: 0;
}
table .image{
  height: 3rem;
  width: 3rem;
}
.zoom-back-0{
  z-index: 0;
}
.zoom-back-1{
  z-index: 1;
}
.zoom-back-2{
  z-index: 2;
}
.zoom-back-3{
  z-index: 3;
}

@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
  .textarea-margin {
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
</style>
